import React, { useEffect, useState } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { ReactComponent as DeclineIcon } from 'assets/svg/shared/decline.svg'
import { ReactComponent as TransferIcon } from 'assets/svg/dialpad/transfer.svg'
import { PageHeaderWithButtons } from 'components/shared'
import { useTranslation } from 'react-i18next'
import './Conference.scss'
import Webphone from 'common/Webphone'
import { setTransferModalVisible } from 'store/actions/global'
import { setCallTransfer } from 'store/actions/call'

export const Conference = () => {
    const dispatch = useDispatch()
    const { calls } = useSelector((state) => state.call)
    const [conferenceNumbers, setConferenceNumbers] = useState([])

    useEffect(() => {
        const conferenceCalls = calls.filter(item => item.isConference)
        conferenceCalls.length && setConferenceNumbers(conferenceCalls[0]?.numbers || [])
    }, [calls])

    const onDeclineClick = (number) => {
        Webphone.hangup(number, false)
    }

    const onTransferClick = (number) => {
        dispatch(setCallTransfer({ isOnTransfer: true, transferNumber: number }))
        dispatch(setTransferModalVisible(true))
    }

    const { t } = useTranslation()

    return (
        <>
            <PageHeaderWithButtons pageName={t('conference')} />
            <div className="conference">
                {conferenceNumbers.map((number) => (
                    <div key={number} className="conference__item d-flex align-items-center">
                        <span className="conference__item__phone">{number}</span>
                        <div className="d-flex align-items-center ml-auto">
                            <button
                                type="button"
                                className="conference__item__transfer-btn d-flex align-items-center justify-content-center"
                                onClick={() => onTransferClick(number)}
                            >
                                <TransferIcon />
                            </button>
                            <button
                                type="button"
                                className="conference__item__decline-btn d-flex justify-content-center align-items-center"
                                onClick={() => onDeclineClick(number)}
                            >
                                <DeclineIcon />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}
